export default "__VITE_ASSET__COnc7xh6__"